export const ErrorCreateDivisionMessage = {
  no_info: "Không có dữ liệu employee",
  existed: "User already in another department or another division",
  dpm_user_existed: "Employees already in another department",
  sever_err: "Server Error",
  active_divisions : "Divisions still active in department",
  not_found_employee : "Not found employee",
  user_inactive: "User not active"
};

export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_FORMAT_YY = "DD/MM/YY";
export const DATE_FORMAT_WITH_TIME_4DIGITS = "DD/MM/YYYY HH:mm:ss";
export const DATE_FORMAT_WITH_TIME = "DD/MM/YY HH:mm:ss";

export const DAY_OFFSET_FOR_LATE_TASK_OF_WORK = 2;

export const DASHBOARD_URL = {
  STATISTICS_TASK_OF_WORK: "/dashboard/tasks-statistics"
}

export const CEO_ROLE_NAME = "CEO";
export const CORP_AUD_WORKSPACE_CODE = "CORP_AUD";
export const RISK_MANAGEMENT_WORKSPACE_CODE = "40HO105032";
export const CHECK_LIST_STATUS = {
  PASS: 1,
  NO_PASS: 2,
}
export const ROOT_MENU_KEY = {
  MAGIC_MIRROR: "MAGIC_MIRROR",
  DASHBOARD: "DASHBOARD",
  G_PERFORMANCE: "G_PERFORMANCE",
  OKR: "OKR",
  G_PROCESS: "G_PROCESS",
  G_TICKET: "G_TICKET",
  TASK_REPORT: "TASK_REPORT",
  TASK_EVALUATION: "TASK_EVALUATION",
  TIME_SHEET_MANAGEMENT: "TIME_SHEET_MANAGEMENT",
  SYSTEM_MANAGEMENT: "SYSTEM_MANAGEMENT",
  INFORMATION: "INFORMATION",
};
